import list from './list'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state
  ),
  mutations: Object.assign(
    list.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/insurance/index.js